(function () {
  if (window.__mtCardPixInitialized) return;
  window.__mtCardPixInitialized = true;

  function parseMoney(text) {
    var match = String(text || "").match(/R\$\s*[\d.]+,\d{2}/i);
    if (!match) return null;
    var n = parseFloat(
      match[0]
        .replace(/R\$\s*/i, "")
        .replace(/\./g, "")
        .replace(",", "."),
    );
    return isFinite(n) ? n : null;
  }
  function moneyBRL(value) {
    return Number(value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
  function makePix(base) {
    var el = document.createElement("div");
    el.className = "mt-pix-price";
    el.innerHTML =
      "<strong>" +
      moneyBRL(base * 0.95) +
      "</strong><span>no Pix <b>5% OFF</b></span>";
    return el;
  }
  function applyHome(root) {
    var cards = (root || document).querySelectorAll
      ? (root || document).querySelectorAll(".mt-card")
      : [];
    Array.prototype.forEach.call(cards, function (card) {
      if (card.querySelector(".mt-pix-price")) return;
      var price = card.querySelector(".mt-card__price");
      if (!price) return;
      if (/no\s*pix/i.test(price.textContent)) return;
      var base = parseMoney(price.textContent);
      if (base === null) return;
      price.parentNode.insertBefore(makePix(base), price);
      card.classList.add("mt-has-pix-price");
      var installment = card.querySelector(".mt-card__installment");
      if (installment)
        installment.textContent =
          "ou " + moneyBRL(base) + " nos demais pagamentos";
    });
  }
  function applyGeneric(root) {
    var lists = (root || document).querySelectorAll
      ? (root || document).querySelectorAll(".product-item__price-list")
      : [];
    Array.prototype.forEach.call(lists, function (list) {
      if (list.querySelector(".mt-pix-price")) return;
      Array.prototype.forEach.call(
        list.querySelectorAll(".parcelamento"),
        function (p) {
          if (/via\s*pix/i.test(p.textContent)) p.style.display = "none";
        },
      );
      var price = list.querySelector(".price:not(.price--compare)");
      if (!price) return;
      var base = parseMoney(price.textContent);
      if (base === null) return;
      list.insertBefore(makePix(base), list.firstChild);
      var hasOther = false;
      Array.prototype.forEach.call(
        list.querySelectorAll(".parcelamento"),
        function (p) {
          if (!/via\s*pix/i.test(p.textContent)) hasOther = true;
        },
      );
      if (!hasOther) {
        var other = document.createElement("div");
        other.className = "mt-pix-other";
        other.textContent = "ou " + moneyBRL(base) + " nos demais pagamentos";
        list.appendChild(other);
      }
    });
  }
  function apply(root) {
    applyHome(root);
    applyGeneric(root);
  }
  function boot() {
    apply(document);
    if (!document.documentElement) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node && node.nodeType === 1) {
            apply(node);
            if (node.matches && node.matches(".mt-card"))
              applyHome(node.parentNode || document);
            if (node.matches && node.matches(".product-item__price-list"))
              applyGeneric(node.parentNode || document);
          }
        });
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
